
import React, { useEffect,useState,useRef  } from 'react';
import {Menu,Button,Dropdown,message} from 'antd'
import {api_candidates_list, api_candidates_edit_status} from '../../api';
import { ProTable } from '@ant-design/pro-components';
import { UnorderedListOutlined,EditOutlined,EllipsisOutlined,PlusOutlined } from '@ant-design/icons';
import CallrecordModel from './callrecord.jsx';
import OplogModel from './oplog.jsx';
import CandidateEdit from './candidateEdit.jsx';
import StatusColumn from './statuscolumn.jsx';
import ChangeIntvTime from './changeIntvTime.jsx';
import { waitTime } from '../../utils/global.js';
import { localStorageGet } from '../../utils/global.js';

const screenHeight = document.body.clientHeight;
// const screenWidth = document.body.clientWidth;

const App = (props) => {
    const {from, showModal, rowInfo, invitationStatusEnum,candidatesStatusEnum,interviewEnum,positionEnum} = props;
    console.log(' --candidate--rowInfo--- ',rowInfo)
    const actionRef = useRef();

    const [showCallRecordModal, setshowCallRecordModal] = useState(false);
    const [showOplogModal, setShowOplogModal] = useState(false);
    const [curRowInfo, setCurRowInfo] = useState({});
    const [pagination, setPagination] = useState({current:1,pageSize:10,total:0});
    const [showEditModal, setEditShowModal] = useState(false);
    const [showChangeIntvTimeModal, setShowChangeIntvTimeModal] = useState(false);
    const [orderCreatUserEnum, setOrderCreatUserEnum] = useState({});

    const currentUserinfo = localStorageGet('UserInfo_k');

    useEffect(() => {
      if(showModal && rowInfo.work_order_id && from=='order')
        actionRef.current?.reload();
    }, [showModal, rowInfo, from]);

    const closeModal = () =>{
      setshowCallRecordModal(false);
      setShowOplogModal(false);
      setEditShowModal(false);
      setShowChangeIntvTimeModal(false);
    }
  
  // 修改工单状态
  const editStatus = (candidate_id,action)=>{
    console.log(candidate_id,action)
    try {
      api_candidates_edit_status({candidate_id:candidate_id, action:action}).then((res) => {
        console.log('api_candidates_edit_status-res-----------------', res);
        if (res.data.code == 9) {
            message.success("操作成功");
            actionRef.current?.reload();
        }else
          message.error(res.data.msg);
      });
    } catch (error) {
      message.error("异常");
      return false;
    }
  }

    let columns = [
      {
        title: '工单ID',
        dataIndex: 'work_order_id',
        search:false,
        key:"work_order_id",
        width: 220,
        ellipsis: true,
      },
          // {
        //   title: 'id',
        //   dataIndex: 'candidate_id',
        //   key: 'candidate_id',
        //   search: false,
        //   width:60
        // },
        {
          title: '姓名',
          dataIndex: 'name',
          key: 'name',
          order:3,
          width: 100,
          ellipsis: true,
          formItemProps: {
            labelCol: { span: 8 }, // 设置搜索项名称的宽度
          },
        },
        {
          title: '手机',
          dataIndex: 'phone',
          key: 'phone',
          width: 100,
          search: false,
          formItemProps: {
            labelCol: { span: 8 }, // 设置搜索项名称的宽度
          },
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          key: 'email',
          search: false,
          ellipsis: true,
        },
        {
          title: '面试官',
          dataIndex: 'interviewer_id',
          key:"interviewer_id",
          // search:false,
          order:5,
          hideInTable:from=='order'?true:false,
          width: 100,
          ellipsis: true,
          valueType: 'select',
          valueEnum: interviewEnum,
          formItemProps: {
            labelCol: { span: 8 }, // 设置搜索项名称的宽度
          },
        },
        {
          title: '工作岗位',
          dataIndex: 'position_id',
          key:"position_id",
          // search:false,
          order:4,
          hideInTable:from=='order'?true:false,
          width: 100,
          ellipsis: true,
          valueType: 'select',
          valueEnum: positionEnum,
          formItemProps: {
            labelCol: { span: 8 }, // 设置搜索项名称的宽度
          },
        },
        {
          title:'工单创建时间',
          dataIndex: 'order_creat_time',
          key:"order_creat_time",
          order:1,
          hideInTable:from=='order'?true:false,
          valueType: "dateRange",
          width: 150,
          fieldProps: {
            picker: "date",
            format:'YYYY-MM-DD',
            allowClear:true,
            // defaultValue:[moment(startTime), moment(endTime)]
          },
          formItemProps: {
            labelCol: { span: 8 }, // 设置搜索项名称的宽度
          },
          render: (_,record) => {
            return record.order_creat_time
          }
        },
        {
          title: '工单创建人',
          dataIndex: 'order_creat_userid',
          key:"order_creat_userid",
          // search:false,
          order:2,
          hideInTable:from=='order'?true:false,
          width: 100,
          ellipsis: true,
          valueType: 'select',
          valueEnum: orderCreatUserEnum,
          formItemProps: {
            labelCol: { span: 8 }, // 设置搜索项名称的宽度
          },
        },
        {
          title: '状态',
          dataIndex: 'invitation_status',
          key: 'invitation_status',
          valueType: 'select',
          valueEnum: invitationStatusEnum,
          // search: false,
          order: 6,
          width: 120,
          ellipsis: true,
          formItemProps: {
            labelCol: { span: 8 }, // 设置搜索项名称的宽度
          },
          render: (_, record) => <StatusColumn record={record} valueEnum={invitationStatusEnum} islink={true}/>
        },
        // {
        //   title: '操作状态',
        //   dataIndex: 'status',
        //   key: 'status',
        //   order: 6,
        //   valueType: 'select',
        //   valueEnum: candidatesStatusEnum,
        //   width: 90,
        //   formItemProps: {
        //     labelCol: { span: 8 }, // 设置搜索项名称的宽度
        //   },
        // },
        {
          title: '最近操作',
          dataIndex: 'last_call_time',
          key: 'last_call_time',
          search: false,
          width: 150,
        },
        {
          title: '通话记录',
          dataIndex: 'communication_record',
          key: 'communication_record',
          search: false,
          // ellipsis: true,
          width: 80,
          render: (text, record, _, action) => [
            // "13244687914",' ',"柴鑫","\n","18145503713",' ',"ascnv"
            <UnorderedListOutlined 
              onClick={()=>{
                setCurRowInfo(record);
                setshowCallRecordModal(true);
              }} />
          ]
        },
        {
          title: '操作记录',
          dataIndex: 'oplog',
          key: 'oplog',
          search: false,
          // ellipsis: true,
          width: 80,
          render: (text, record, _, action) => [
            // "13244687914",' ',"柴鑫","\n","18145503713",' ',"ascnv"
            <UnorderedListOutlined 
              onClick={()=>{
                setCurRowInfo(record);
                setShowOplogModal(true);
              }} />
          ]
        },
      ];
      if(currentUserinfo.roleid=='2') 
        columns.push({
          title: '操作',
          valueType: 'option',
          width: 80,
          search: false,
          key: 'option',
          render: (text, record, _, action) => !invitationStatusEnum.hasOwnProperty(record.invitation_status)?[]:[
            invitationStatusEnum[record.invitation_status].edit=='1'?
            <a  key={"editcanda"+record.candidate_id}
              onClick={async() => {
                console.log('record ------------- ', record)
                console.log('action ------------- ', action)
                // action?.startEditable?.(record.id);
                setCurRowInfo(record);
                await waitTime(100);
                setEditShowModal(true);
              }}
            >
              <EditOutlined  key={"editcand"+record.candidate_id}
                style={{backgroundColor:"rgb(24,188,156)",padding:"2px 3px",borderRadius:3,color:"white"}} />
            </a>:
            <EditOutlined  key={"edit"+record.tenant_id}
            style={{backgroundColor:"#ccc",padding:"2px 3px",borderRadius:3,color:"white",cursor:"not-allowed"}} />
            ,
            // record.roleid!=99 && 
            // <Popconfirm  key={"delpop"+record.tenant_id}
            //   title="确定删除吗?" onConfirm={() => {delComp(record.cid)}}>
            //   <DeleteOutlined  key={"del"+record.tenant_id}
            //     style={{backgroundColor:"#ff4d4f",padding:"2px 3px",borderRadius:3,color:"white"}} />
            // </Popconfirm>,
            invitationStatusEnum[record.invitation_status].stop!='1' && invitationStatusEnum[record.invitation_status].cancel!='1' && invitationStatusEnum[record.invitation_status].pause!='1' && invitationStatusEnum[record.invitation_status].restart!='1' ? 
            <EllipsisOutlined  style={{color:"#ccc",fontSize:20,cursor:"not-allowed"}}/>:
            <Dropdown overlay={()=>{
              return(
              <Menu onClick={()=>{}} style={{borderRadius:8}} >
                <Menu.Item 
                  style={{display:invitationStatusEnum[record.invitation_status].stop=='1'?'block':'none'}}
                  onClick={()=>{editStatus(record.candidate_id, 'stop')}}>终止
                </Menu.Item> 
                <Menu.Item 
                  style={{display:invitationStatusEnum[record.invitation_status].cancel=='1'?'block':'none'}}
                  onClick={()=>{editStatus(record.candidate_id, 'cancel')}}>取消
                </Menu.Item> 
                <Menu.Item 
                  style={{display:invitationStatusEnum[record.invitation_status].cancel=='1'?'block':'none'}}
                  onClick={async() => {
                    setCurRowInfo(record);
                    await waitTime(100);
                    setShowChangeIntvTimeModal(true);
                  }}>改期
                </Menu.Item> 
                <Menu.Item 
                  style={{display:invitationStatusEnum[record.invitation_status].pause=='1'?'block':'none'}}
                  onClick={()=>{editStatus(record.candidate_id, 'pause')}}>暂停
                </Menu.Item> 
                <Menu.Item 
                  style={{display:invitationStatusEnum[record.invitation_status].restart=='1'?'block':'none'}}
                  onClick={()=>{editStatus(record.candidate_id, 'restart')}}>重启
                </Menu.Item> 
                {/* <Popconfirm
                    title="确认删除该工单？"
                    onConfirm={()=>{
                      // delClient(data.id);
                    }}
                    okText="Yes"
                    cancelText="No"
                >
                  <Menu.Item 
                      // style={{display:isShow('del')?'block':'none'}}
                  >删除</Menu.Item> 
                </Popconfirm> */}
                
              </Menu>
              )}}>
              <EllipsisOutlined  style={{color:"rgb(63,140,255)",fontSize:20}}/>
            </Dropdown>
          // <a href={record.url} target="_blank" rel="noopener noreferrer" key="view">
            //   查看
            // </a>,
            // <TableDropdown
            //   key="actionGroup"
            //   onSelect={() => action?.reload()}
            //   menus={[
            //     { key: 'copy', name: '复制' },
            //     { key: 'delete', name: '删除' },
            //   ]}
            // />,
          ],
        });
        // {
        //   title: '允许外呼否',
        //   dataIndex: 'allowcall',
        //   key: 'allowcall',
        //   search: false,
        //   render: (text, record, _, action) => <Switch  defaultChecked={record.allowcall=='1'?true:false} checkedChildren="允许" unCheckedChildren="停止"/>
        // },
// onChange={onChange} 
  
    return (
      <div>
          <ProTable
            headerTitle={from=='order'?"":"候选人列表"}
            columns={columns}
            actionRef={actionRef}
            rowKey="candidate_id"
            cardBordered
            defaultSize="small"
            request={async (params, sort, filter) => {
              console.log(params,sort, filter);
              // await waitTime(2000);
              var tableData = [];
              if(showModal && ((rowInfo.work_order_id && from=='order') || from=='menu')){
                params.from = from;
                params.work_order_id = rowInfo.work_order_id;
                var res = await api_candidates_list(params);
                console.log('api_candidates_list-res-----------------', res);
                if(res.data.code == 9){
                  var enums = {};
                  for(let v of res.data.userlist)
                    enums[v.id] = {text:v.username};
                  console.log('------------enums--------------', enums)
                  setOrderCreatUserEnum(enums);
                  waitTime(100);
                  tableData = res.data.list;
                  setPagination({current:parseInt(res.data.pageinfo.current), pageSize:parseInt(res.data.pageinfo.pageSize), total:parseInt(res.data.pageinfo.total)})
                }else
                  message.error(res.data.msg);
              }

              return {
                data: tableData,
                // current: res.data.pageNo,
                // pageSize: res.data.pageSize,
                success: true,
                // total: res.data.totalRows,
              };
            }}
            search={from=='order'?false:true}
            options={{
              reload: false, // 去掉刷新按钮
              density: false, // 去掉密度按钮
              setting: true, // 保留列设置按钮
              setting: {
                listsHeight: 400,
              },
            }}
            style={{lineHeight: '0.40rem',marginTop:'0.32rem',overflowX: 'scroll',overflowY: 'scroll'}}  
            scroll={{x:from=='order'?800:1500}}
            columnsState={{
              persistenceKey: 'pro-table-candidate',
              persistenceType: 'localStorage',
              onChange(value) {
                console.log('value: ', value);
              },
            }}

            // form={{
            //   // 由于配置了 transform，提交的参与与定义的不同这里需要转化一下
            //   syncToUrl: (values, type) => {
            //     if (type === 'get') {
            //       return {
            //         ...values,
            //         created_at: [values.startTime, values.endTime],
            //       };
            //     }
            //     return values;
            //   },
            // }}
            pagination={from=='order'?false:{
              // pageSizeOptions: [10, 20, 50, 100, pagination.total],
              showSizeChanger: true,
              pageSize: pagination.pageSize,
              current:pagination.current,
              total:pagination.total,
              onChange: (page) => console.log(page),
            }}
      
                  // dateFormatter="string"

            toolBarRender={() => [<Button
              key="button"
              icon={<PlusOutlined />}
              // style={{backgroundColor:"rgb(5,168,137)"}}
              onClick={async() => {
                setCurRowInfo({work_order_id:rowInfo.work_order_id, tenant_id:rowInfo.tenant_id});
                await waitTime(100);
                setEditShowModal(true);
              }}
              type="primary"
              disabled={from=='order'&&currentUserinfo.roleid=='2'&&!(['105','106','107'].includes(rowInfo.status))?false:true}
              // style={{display:from=='order'&&currentUserinfo.roleid=='2'?'':'none'}}
            >
              新增候选人
            </Button>,]}
          />

        <CallrecordModel
          showModal={showCallRecordModal}
          rowInfo={curRowInfo}
          closeModal={closeModal}
          invitationStatusEnum={invitationStatusEnum}
        />

        <OplogModel
          showModal={showOplogModal}
          rowInfo={curRowInfo}
          closeModal={closeModal}
          from={"candidate"}
        />

        <CandidateEdit
          showModal={showEditModal}
          rowInfo={curRowInfo}
          closeModal={closeModal}
          refreshlist={()=>{actionRef.current?.reload();}}
        />

        <ChangeIntvTime
          showModal={showChangeIntvTimeModal}
          rowInfo={curRowInfo}
          closeModal={closeModal}
          refreshlist={()=>{actionRef.current?.reload();}}
        />
      </div>

    )
}

export default App